<template>
    <properties-block  v-bind="$props" v-on="$listeners">
        <properties-component-image title="Banner Image|Image bannière" :value="block.bannerImage" v-bind="componentProps"
                        no-link/>
    </properties-block>
</template>

<script>
import PropertiesComponentImage from "@/components/editor/properties/components/properties-component-image.vue";
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";

// properties-block-map #hot-reload-debug
export default {
    name: `properties-block-map`,
    components: {PropertiesComponentImage, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
